import { Component, OnInit } from '@angular/core';
import { NgxGalleryOptions, NgxGalleryImage, NgxGalleryAnimation } from 'ngx-gallery';
import { Title, Meta } from '@angular/platform-browser';
import 'hammerjs';

@Component({
  selector: 'app-galeria',
  templateUrl: './galeria.component.html',
  styleUrls: ['./galeria.component.css']
})
export class GaleriaComponent implements OnInit {

  galleryOptions: NgxGalleryOptions[];
  galleryImagesKuchyne: NgxGalleryImage[];
  galleryImagesSchody: NgxGalleryImage[];
  galleryImagesDvere: NgxGalleryImage[];
  galleryImagesOstatne: NgxGalleryImage[];
  galleryImagesAltanky: NgxGalleryImage[];

  constructor(private titleService: Title,
    private metaTagService: Meta) { }

  ngOnInit(): void {
    this.titleService.setTitle("Stolarstvo-Krisanda: Galeria produktov");
    this.metaTagService.updateTag({name: 'description', content: "Stolárstvo Krišanda nábytok namieru. Galéria produktov: kuchyne, dvere, schody, komody, skrine, spalne exterierovy nabytok, altanok."});

    this.galleryOptions = [
            {
                width: '600px',
                height: '400px',
                thumbnailsColumns: 4,
                imageAnimation: NgxGalleryAnimation.Slide,
                previewCloseOnClick: true, previewCloseOnEsc: true
            },
            // max-width 800
            {
                breakpoint: 800,
                width: '100%',
                height: '600px',
                imagePercent: 80,
                thumbnailsPercent: 20,
                thumbnailsMargin: 20,
                thumbnailMargin: 20,
                previewCloseOnClick: true,
                previewCloseOnEsc: true
            },
            // max-width 400
            {
                width: '100%',
                height: '400px',
                breakpoint: 400,
                thumbnailsPercent: 20,
                thumbnailsMargin: 20,
                thumbnailMargin: 20,
                imagePercent: 60,
            }
        ];


    this.galleryImagesKuchyne = [
      {
        small: '../../assets/images/kuchyne/ku-18-sm.jpg',
        medium: '../../assets/images/kuchyne/ku-18-sm.jpg',
        big: '../../assets/images/kuchyne/ku-18.jpg'
      },
      {
        small: '../../assets/images/kuchyne/ku-1-sm.png',
        medium: '../../assets/images/kuchyne/ku-1-sm.png',
        big: '../../assets/images/kuchyne/ku-1.png'
      },
      {
        small: '../../assets/images/kuchyne/ku-2-sm.png',
        medium: '../../assets/images/kuchyne/ku-2-md.png',
        big: '../../assets/images/kuchyne/ku-2.png'
      },
      {
        small: '../../assets/images/kuchyne/ku-3-sm.png',
        medium: '../../assets/images/kuchyne/ku-3-sm.png',
        big: '../../assets/images/kuchyne/ku-3.png'
      },
      {
        small: '../../assets/images/kuchyne/ku-4-sm.png',
        medium: '../../assets/images/kuchyne/ku-4-sm.png',
        big: '../../assets/images/kuchyne/ku-4.png'
      },
      {
        small: '../../assets/images/kuchyne/ku-5-sm.png',
        medium: '../../assets/images/kuchyne/ku-5-sm.png',
        big: '../../assets/images/kuchyne/ku-5.png'
      },
      {
        small: '../../assets/images/kuchyne/ku-6-sm.png',
        medium: '../../assets/images/kuchyne/ku-6-sm.png',
        big: '../../assets/images/kuchyne/ku-6.png'
      },
      {
        small: '../../assets/images/kuchyne/ku-7-sm.png',
        medium: '../../assets/images/kuchyne/ku-7-md.png',
        big: '../../assets/images/kuchyne/ku-7.png'
      },
      {
        small: '../../assets/images/kuchyne/ku-8-sm.png',
        medium: '../../assets/images/kuchyne/ku-8-md.png',
        big: '../../assets/images/kuchyne/ku-8.png'
      },
      {
        small: '../../assets/images/kuchyne/ku-9-sm.png',
        medium: '../../assets/images/kuchyne/ku-9-md.png',
        big: '../../assets/images/kuchyne/ku-9.png'
      },
      {
        small: '../../assets/images/kuchyne/ku-10-sm.png',
        medium: '../../assets/images/kuchyne/ku-10-sm.png',
        big: '../../assets/images/kuchyne/ku-10.png'
      },
      {
        small: '../../assets/images/kuchyne/ku-11-sm.png',
        medium: '../../assets/images/kuchyne/ku-11-sm.png',
        big: '../../assets/images/kuchyne/ku-11.png'
      },
      {
        small: '../../assets/images/kuchyne/ku-12-sm.png',
        medium: '../../assets/images/kuchyne/ku-12-sm.png',
        big: '../../assets/images/kuchyne/ku-12.png'
      },
      {
        small: '../../assets/images/kuchyne/ku-13-sm.png',
        medium: '../../assets/images/kuchyne/ku-13-sm.png',
        big: '../../assets/images/kuchyne/ku-13.png'
      },
      {
        small: '../../assets/images/kuchyne/ku-14-sm.png',
        medium: '../../assets/images/kuchyne/ku-14-sm.png',
        big: '../../assets/images/kuchyne/ku-14.png'
      },
      {
        small: '../../assets/images/kuchyne/ku-15-sm.png',
        medium: '../../assets/images/kuchyne/ku-15-sm.png',
        big: '../../assets/images/kuchyne/ku-15.png'
      },
      {
        small: '../../assets/images/kuchyne/ku-16-sm.png',
        medium: '../../assets/images/kuchyne/ku-16-sm.png',
        big: '../../assets/images/kuchyne/ku-16.png'
      },
      {
        small: '../../assets/images/kuchyne/ku-17-sm.png',
        medium: '../../assets/images/kuchyne/ku-17-sm.png',
        big: '../../assets/images/kuchyne/ku-17.png'
      }
    ];

    this.galleryImagesSchody = [
      {
        small: '../../assets/images/schody/sc-1-sm.png',
        medium: '../../assets/images/schody/sc-1-md.png',
        big: '../../assets/images/schody/sc-1.png'
      },
      {
        small: '../../assets/images/schody/sc-2-sm.png',
        medium: '../../assets/images/schody/sc-2-sm.png',
        big: '../../assets/images/schody/sc-2.png'
      },
      {
        small: '../../assets/images/schody/sc-3-sm.png',
        medium: '../../assets/images/schody/sc-3-sm.png',
        big: '../../assets/images/schody/sc-3.png'
      },
      {
        small: '../../assets/images/schody/sc-4-sm.png',
        medium: '../../assets/images/schody/sc-4-sm.png',
        big: '../../assets/images/schody/sc-4.png'
      },
      {
        small: '../../assets/images/schody/sc-5-sm.png',
        medium: '../../assets/images/schody/sc-5-sm.png',
        big: '../../assets/images/schody/sc-5.png'
      },
      {
        small: '../../assets/images/schody/sc-6-sm.png',
        medium: '../../assets/images/schody/sc-6-sm.png',
        big: '../../assets/images/schody/sc-6.png'
      },
      {
        small: '../../assets/images/schody/sc-7-sm.png',
        medium: '../../assets/images/schody/sc-7-sm.png',
        big: '../../assets/images/schody/sc-7.png'
      },
      {
        small: '../../assets/images/schody/sc-8-sm.png',
        medium: '../../assets/images/schody/sc-8-sm.png',
        big: '../../assets/images/schody/sc-8.png'
      },
    ];

    this.galleryImagesDvere = [
      {
        small: '../../assets/images/dvere/dv-1-sm.jpg',
        medium: '../../assets/images/dvere/dv-1-sm.jpg',
        big: '../../assets/images/dvere/dv-1.jpg'
      },
      {
        small: '../../assets/images/dvere/dv-2-sm.jpg',
        medium: '../../assets/images/dvere/dv-2-sm.jpg',
        big: '../../assets/images/dvere/dv-2.jpg'
      },
      {
        small: '../../assets/images/dvere/dv-3-sm.jpg',
        medium: '../../assets/images/dvere/dv-3-sm.jpg',
        big: '../../assets/images/dvere/dv-3.JPG'
      },
      {
        small: '../../assets/images/dvere/dv-4-sm.png',
        medium: '../../assets/images/dvere/dv-4-sm.png',
        big: '../../assets/images/dvere/dv-4.jpg'
      },
      {
        small: '../../assets/images/dvere/dv-5-sm.png',
        medium: '../../assets/images/dvere/dv-5-sm.png',
        big: '../../assets/images/dvere/dv-5.jpg'
      },
      {
        small: '../../assets/images/dvere/dv-6-sm.png',
        medium: '../../assets/images/dvere/dv-6-sm.png',
        big: '../../assets/images/dvere/dv-6.png'
      },
      {
        small: '../../assets/images/dvere/dv-7-sm.png',
        medium: '../../assets/images/dvere/dv-7-sm.png',
        big: '../../assets/images/dvere/dv-7.png'
      },
      {
        small: '../../assets/images/dvere/dv-8-sm.png',
        medium: '../../assets/images/dvere/dv-8-md.png',
        big: '../../assets/images/dvere/dv-8.png'
      },
      {
        small: '../../assets/images/dvere/dv-9-sm.png',
        medium: '../../assets/images/dvere/dv-9-md.png',
        big: '../../assets/images/dvere/dv-9.png'
      },
      {
        small: '../../assets/images/dvere/dv-10-sm.png',
        medium: '../../assets/images/dvere/dv-10-md.png',
        big: '../../assets/images/dvere/dv-10.png'
      },
      {
        small: '../../assets/images/dvere/dv-11-sm.png',
        medium: '../../assets/images/dvere/dv-11-md.png',
        big: '../../assets/images/dvere/dv-11.png'
      }
    ];

    this.galleryImagesOstatne = [
      {
        small: '../../assets/images/ostatne/os-17-sm.jpg',
        medium: '../../assets/images/ostatne/os-17-sm.jpg',
        big: '../../assets/images/ostatne/os-17.jpg'
      },
      {
        small: '../../assets/images/ostatne/os-1-sm.png',
        medium: '../../assets/images/ostatne/os-1-sm.png',
        big: '../../assets/images/ostatne/os-1.png'
      },
      {
        small: '../../assets/images/ostatne/os-2-sm.png',
        medium: '../../assets/images/ostatne/os-2-sm.png',
        big: '../../assets/images/ostatne/os-2.png'
      },
      {
        small: '../../assets/images/ostatne/os-3-sm.png',
        medium: '../../assets/images/ostatne/os-3-sm.png',
        big: '../../assets/images/ostatne/os-3.png'
      },
      {
        small: '../../assets/images/ostatne/os-4-sm.png',
        medium: '../../assets/images/ostatne/os-4-sm.png',
        big: '../../assets/images/ostatne/os-4.png'
      },
      {
        small: '../../assets/images/ostatne/os-5-sm.png',
        medium: '../../assets/images/ostatne/os-5-sm.png',
        big: '../../assets/images/ostatne/os-5.png'
      },
      {
        small: '../../assets/images/ostatne/os-6-sm.png',
        medium: '../../assets/images/ostatne/os-6-sm.png',
        big: '../../assets/images/ostatne/os-6.png'
      },
      {
        small: '../../assets/images/ostatne/os-7-sm.png',
        medium: '../../assets/images/ostatne/os-7-sm.png',
        big: '../../assets/images/ostatne/os-7.png'
      },
      {
        small: '../../assets/images/ostatne/os-8-sm.png',
        medium: '../../assets/images/ostatne/os-8-sm.png',
        big: '../../assets/images/ostatne/os-8.png'
      },
      {
        small: '../../assets/images/ostatne/os-9-sm.png',
        medium: '../../assets/images/ostatne/os-9-sm.png',
        big: '../../assets/images/ostatne/os-9.png'
      },
      {
        small: '../../assets/images/ostatne/os-10-sm.png',
        medium: '../../assets/images/ostatne/os-10-sm.png',
        big: '../../assets/images/ostatne/os-10.png'
      },
      {
        small: '../../assets/images/ostatne/os-11-sm.png',
        medium: '../../assets/images/ostatne/os-11-md.png',
        big: '../../assets/images/ostatne/os-11.png'
      },
      {
        small: '../../assets/images/ostatne/os-13-sm.png',
        medium: '../../assets/images/ostatne/os-13-sm.png',
        big: '../../assets/images/ostatne/os-13.png'
      },
      {
        small: '../../assets/images/ostatne/os-14-sm.png',
        medium: '../../assets/images/ostatne/os-14-sm.png',
        big: '../../assets/images/ostatne/os-14.png'
      },
      {
        small: '../../assets/images/ostatne/os-15-sm.png',
        medium: '../../assets/images/ostatne/os-15-sm.png',
        big: '../../assets/images/ostatne/os-15.png'
      },
      {
        small: '../../assets/images/ostatne/os-16-sm.png',
        medium: '../../assets/images/ostatne/os-16-sm.png',
        big: '../../assets/images/ostatne/os-16.png'
      }
    ];

    this.galleryImagesAltanky = [
      {
        small: '../../assets/images/altanky/al-1-sm.png',
        medium: '../../assets/images/altanky/al-1-sm.png',
        big: '../../assets/images/altanky/al-1.png'
      },
      {
        small: '../../assets/images/altanky/al-2-sm.png',
        medium: '../../assets/images/altanky/al-2-sm.png',
        big: '../../assets/images/altanky/al-2.png'
      },
      {
        small: '../../assets/images/altanky/al-4-sm.png',
        medium: '../../assets/images/altanky/al-4-sm.png',
        big: '../../assets/images/altanky/al-4.png'
      }
    ];

  }

}
